import type { FlashDiscountProductListResponse } from '../../services/models/flash-discount';

export default function flashProductsResponseAdapter(response: FlashDiscountProductListResponse) {
  return {
    items: response?.items || [],
    totalCount: response?.totalCount || 0,
    itemCount: response?.itemCount || 0,
    pageCount: response?.pageCount || 0,
    currentPage: response?.currentPage || 0,
    limit: response?.limit || 0,
  };
}
